// export const SERVER_URL = 'http://localhost:5000'
export const SERVER_URL = 'https://wanderlust-bh2e.onrender.com'

export const SERVER_ADMIN_URL = SERVER_URL + '/admin'
export const SERVER_USER_URL = SERVER_URL + '/user'
